import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import HollowButton from "components/HollowButton";
import { useTranslation } from "react-i18next";

const ConfirmCloseModal: FC<Props> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return ReactDOM.createPortal(
    <div className={styles.wrapper}>
      <div className={styles.modal}>
        <div className={styles.title}>{t("common.editField")}</div>
        <div className={styles.info}>
          {t("common.closeWithoutSaving")}
        </div>
        <div className={styles.btnWrapper}>
          <HollowButton text={t("common.close")} onClick={onCancel} />
          <HollowButton text={t("common.save")} onClick={onConfirm} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmCloseModal;
